import React from 'react';

const TrustpilotRatingStars = ({ stars }) => {
  const getColor = (starPosition) => {
    const fillColor = stars === 5 ? '#00B67A' : '#73CF11';
    return starPosition <= stars ? fillColor : '#DCDCE6';
  };

  return (
    <svg
      width="129"
      height="24"
      viewBox="0 0 129 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6901_106055)">
        <path d="M24.3281 0H0.328125V24H24.3281V0Z" fill={getColor(1)} />
        <path d="M50.3281 0H26.3281V24H50.3281V0Z" fill={getColor(2)} />
        <path d="M76.3281 0H52.3281V24H76.3281V0Z" fill={getColor(3)} />
        <path d="M102.328 0H78.3281V24H102.328V0Z" fill={getColor(4)} />
        <path d="M128.328 0H104.328V24H128.328V0Z" fill={getColor(5)} />
        <path
          d="M12.3297 16.1758L15.9797 15.2508L17.5047 19.9508L12.3297 16.1758ZM20.7297 10.1008H14.3047L12.3297 4.05078L10.3547 10.1008H3.92969L9.12969 13.8508L7.15469 19.9008L12.3547 16.1508L15.5547 13.8508L20.7297 10.1008Z"
          fill="white"
        />
        <path
          d="M38.3297 16.1758L41.9797 15.2508L43.5047 19.9508L38.3297 16.1758ZM46.7297 10.1008H40.3047L38.3297 4.05078L36.3547 10.1008H29.9297L35.1297 13.8508L33.1547 19.9008L38.3547 16.1508L41.5547 13.8508L46.7297 10.1008Z"
          fill="white"
        />
        <path
          d="M64.3297 16.1758L67.9797 15.2508L69.5047 19.9508L64.3297 16.1758ZM72.7297 10.1008H66.3047L64.3297 4.05078L62.3547 10.1008H55.9297L61.1297 13.8508L59.1547 19.9008L64.3547 16.1508L67.5547 13.8508L72.7297 10.1008Z"
          fill="white"
        />
        <path
          d="M90.3297 16.1758L93.9797 15.2508L95.5047 19.9508L90.3297 16.1758ZM98.7297 10.1008H92.3047L90.3297 4.05078L88.3547 10.1008H81.9297L87.1297 13.8508L85.1547 19.9008L90.3547 16.1508L93.5547 13.8508L98.7297 10.1008Z"
          fill="white"
        />
        <path
          d="M116.33 16.1758L119.98 15.2508L121.505 19.9508L116.33 16.1758ZM124.73 10.1008H118.305L116.33 4.05078L114.355 10.1008H107.93L113.13 13.8508L111.155 19.9008L116.355 16.1508L119.555 13.8508L124.73 10.1008Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6901_106055">
          <rect
            width="128"
            height="24"
            fill="white"
            transform="translate(0.328125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

TrustpilotRatingStars.displayName = 'TrustpilotStars';
export default TrustpilotRatingStars;
